import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './UserMenu.module.css';

export default function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function handleClickOutside(e: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    function handleEscape(e: KeyboardEvent) {
      if (e.key === 'Escape') setOpen(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [open]);

  function handleMiCuenta() {
    setOpen(false);
    navigate('/mi-cuenta');
  }

  function handleLogout() {
    setOpen(false);
    logout();
  }

  return (
    <div className={styles.container} ref={containerRef}>
      <button type="button" className={styles.trigger} onClick={() => setOpen((v) => !v)}>
        <span className={styles.avatar}>{(user?.nombre ?? '?').charAt(0).toUpperCase()}</span>
        <span className={styles.triggerName}>{user?.nombre ?? 'Cuenta'}</span>
        <span className={styles.chevron}>▾</span>
      </button>

      {open && (
        <div className={styles.menu} role="menu">
          <div className={styles.menuHeader}>Mi cuenta</div>
          {user?.role !== 'MEDICO' && (
            <button type="button" className={styles.menuItem} role="menuitem" onClick={handleMiCuenta}>
              <span className={styles.menuIcon}>👤</span>
              Mi cuenta
            </button>
          )}
          <div className={styles.menuDivider} />
          <button type="button" className={styles.menuItemDanger} role="menuitem" onClick={handleLogout}>
            <span className={styles.menuIcon}>↪</span>
            Cerrar sesión
          </button>
        </div>
      )}
    </div>
  );
}
